export default "__VITE_PUBLIC_ASSET__521f1950__"